import React from "react";
import { Sparkles, Heart, Moon, BadgeCheck } from "lucide-react";
import { useAstrologers } from "../context/AstrologersContext";

const Hero = () => {
  const { meta } = useAstrologers();

  return (
    <section className="hero-band">
      <div className="hero-stars" />
      <div className="hero-stars-2" />
      <div className="shooting-star" />
      <div className="zodiac-wheel" />

      {/* Decorative planets */}
      <div className="planet planet-saturn" aria-hidden="true">
        <div className="saturn-band" />
        <div className="saturn-body" />
        <div className="saturn-band-2" />
      </div>
      <div className="planet planet-orange" aria-hidden="true" />
      <div className="planet planet-purple" aria-hidden="true" />
      <div className="planet planet-teal" aria-hidden="true" />

      {/* Bright glowing stars */}
      <div className="bright-star sparkle s-lg bs-1" aria-hidden="true" />
      <div className="bright-star tint-blue bs-2" aria-hidden="true" />
      <div className="bright-star sparkle tint-gold bs-3" aria-hidden="true" />
      <div className="bright-star s-sm bs-4" aria-hidden="true" />
      <div className="bright-star sparkle s-lg tint-pink bs-5" aria-hidden="true" />
      <div className="bright-star tint-blue bs-6" aria-hidden="true" />
      <div className="bright-star s-sm bs-7" aria-hidden="true" />
      <div className="bright-star sparkle tint-gold bs-8" aria-hidden="true" />
      <div className="bright-star s-sm bs-9" aria-hidden="true" />
      <div className="bright-star sparkle bs-10" aria-hidden="true" />

      <div className="max-w-6xl mx-auto px-4 sm:px-6 relative">
        <div className="py-6 sm:py-12 max-w-2xl">
          {/* Badges */}
          <div className="flex flex-wrap items-center gap-1.5 sm:gap-2 mb-2.5 sm:mb-3">
            <div className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-gradient-to-r from-[#16a34a] to-[#15803d] border border-emerald-300/60 text-[10px] sm:text-xs font-bold text-white shadow-[0_2px_10px_rgba(22,163,74,0.45)]">
              <BadgeCheck className="w-3 h-3 sm:w-3.5 sm:h-3.5 text-white" fill="rgba(255,255,255,0.25)" />
              <span className="tracking-wide">Top 5 • TAI Verified</span>
            </div>
            <div className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-gradient-to-r from-[#facc15] to-[#eab308] border border-yellow-200 text-[10px] sm:text-xs font-bold text-[#3b2a00] shadow-[0_2px_10px_rgba(234,179,8,0.45)]">
              <Sparkles className="w-3 h-3 sm:w-3.5 sm:h-3.5" />
              <span>1,00,000+ seekers</span>
            </div>
          </div>

          {/* Title */}
          <h1 className="hero-text-shadow text-[22px] sm:text-4xl md:text-5xl font-extrabold text-white leading-[1.12] tracking-tight">
            {meta.heroTitle}
          </h1>

          {/* Subtitle — hidden on mobile to keep the banner compact */}
          <p className="hero-text-shadow hidden sm:block mt-3 text-base md:text-lg text-slate-100/95 max-w-xl">
            {meta.heroSubtitle}
          </p>

          {/* Specialty row — single compact line */}
          <div className="mt-3 sm:mt-5 flex flex-wrap items-center gap-2 sm:gap-4 text-white/95">
            <div className="flex items-center gap-1.5">
              <div className="w-6 h-6 sm:w-8 sm:h-8 rounded-md border border-white/40 bg-white/5 flex items-center justify-center">
                <Sparkles className="w-3 h-3 sm:w-3.5 sm:h-3.5" />
              </div>
              <span className="text-[11px] sm:text-sm font-semibold">Vedic</span>
            </div>
            <div className="flex items-center gap-1.5">
              <div className="w-6 h-6 sm:w-8 sm:h-8 rounded-md border border-white/40 bg-white/5 flex items-center justify-center">
                <Heart className="w-3 h-3 sm:w-3.5 sm:h-3.5" />
              </div>
              <span className="text-[11px] sm:text-sm font-semibold">KP</span>
            </div>
            <div className="flex items-center gap-1.5">
              <div className="w-6 h-6 sm:w-8 sm:h-8 rounded-md border border-white/40 bg-white/5 flex items-center justify-center">
                <Moon className="w-3 h-3 sm:w-3.5 sm:h-3.5" />
              </div>
              <span className="text-[11px] sm:text-sm font-semibold">Nadi</span>
            </div>
            <span className="ml-auto text-[10px] sm:text-xs text-white bg-white/15 border border-white/30 rounded px-2 py-1 backdrop-blur-sm whitespace-nowrap">
              {meta.lastUpdated}
            </span>
          </div>
        </div>
      </div>

      <div className="bg-slate-100 border-t border-slate-200">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-1.5 sm:py-2 flex items-center justify-end text-[10px] sm:text-xs text-slate-600">
          <span className="underline decoration-dotted underline-offset-2">{meta.disclosure}</span>
        </div>
      </div>
    </section>
  );
};

export default Hero;
